import { Button, Card, ControlGroup, FormGroup } from "@blueprintjs/core";
import type { ExtraFieldTypeArray } from "@package/ui-gql/index-data-access";
import { get, set } from "lodash";
import { useMemo } from "react";
import { ServiceDataFormField } from "../ServiceDataFormField";
import type { ServiceDataFormFieldBaseProps } from "./ServiceDataFormFieldEmpty";

type ServiceDataFormFieldArrayProps = ServiceDataFormFieldBaseProps & {
  field: ExtraFieldTypeArray;
};

function ServiceDataFormFieldArrayContent({
  data,
  field,
  onSourceChanged,
}: ServiceDataFormFieldArrayProps) {
  const entries = useMemo(() => get(data, field.source), [data, field.source]);

  return (
    <FormGroup>
      {Array.isArray(entries) &&
        entries.map((entry, indexEntry) => (
          <FormGroup
            key={indexEntry}
            label={field.showTitle ? field.label : undefined}
          >
            <Card>
              <ControlGroup fill>
                <ControlGroup fill vertical>
                  {field.extraFields.map((child, indexField) => {
                    return (
                      <ServiceDataFormField
                        key={indexField}
                        field={child}
                        data={entry}
                        onSourceChanged={(callback) => {
                          onSourceChanged((draft) => {
                            const draftEntries = get(draft, field.source);

                            if (
                              Array.isArray(draftEntries) &&
                              indexEntry < draftEntries.length
                            ) {
                              callback(draftEntries[indexEntry]);
                            }
                          });
                        }}
                      />
                    );
                  })}
                </ControlGroup>
                <div className="flex-none">
                  <Button
                    minimal
                    intent="danger"
                    icon="remove"
                    onClick={() =>
                      onSourceChanged((draft) => {
                        const draftEntries = get(draft, field.source);

                        if (
                          Array.isArray(draftEntries) &&
                          draftEntries.length >= indexEntry
                        ) {
                          draftEntries.splice(indexEntry, 1);
                        }
                      })
                    }
                  />
                </div>
              </ControlGroup>
            </Card>
          </FormGroup>
        ))}
      <Button
        minimal
        icon="add"
        intent="primary"
        text={`Add ${field.label}`}
        onClick={() =>
          onSourceChanged((draft) => {
            const draftEntries = get(draft, field.source) ?? [];

            set(draft, field.source, [...draftEntries, {}]);
          })
        }
      />
    </FormGroup>
  );
}

export function ServiceDataFormFieldArray({
  field,
  onSourceChanged,
  data,
}: ServiceDataFormFieldBaseProps) {
  if (field.__typename === "ExtraFieldTypeArray") {
    return (
      <ServiceDataFormFieldArrayContent
        field={field}
        data={data}
        onSourceChanged={onSourceChanged}
      />
    );
  }

  return null;
}
